import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const Espacio = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idEspacio, setIdEspacio] = useState("")
    const [espacio, setEspacio] = useState("")
    const [descripcion, setDescripcion] = useState("")
    // modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Espacio', campo: 'espacio' },
        { titulo: 'Descripcion', campo: 'descripcion' },
    ]

    // Carga inicial de los espacio
    useEffect(() => { obtenerEspacios() }, [])

    // Función para traer los espacio
    const obtenerEspacios = async () => {
        const respuesta = await consumirApi('GET', `maestros/espacio/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    //Funcion para registrar nuevo espacio
    const registrarEspacio = async(e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/espacio`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Espacio registrado correctamente" })
            limpiarCampos()
            obtenerEspacios()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // funcion para abrir el modal para editar espacio
    const abrirModalEditar = (data) => {
        setIdEspacio(data.id)
        setEspacio(data.espacio)
        setDescripcion(data.descripcion)
        setMostrarModalEditar(true)
    }

    // Edición de espacio
    const enviarEdicionEspacio = async (e) => {
        e.preventDefault()
        const data = { espacio, descripcion }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/espacio/${idEspacio}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Espacio actualizado correctamente" })
            limpiarCampos()
            obtenerEspacios()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionEspacio = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para enviar la eliminación de un espacio
    const eliminarEspacio = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/espacio/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Espacio eliminado correctamente" })
            limpiarCampos()
            obtenerEspacios()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setError('')
        setSelectedId(null)
        setEspacio('')
        setDescripcion('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=> setMostrarModalEliminar(true)} />

            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron espacios</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionEspacio} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo espacio*/}
            <Modal isOpen={mostrarModal} title="Registrar nuevo espacio" onClose={limpiarCampos} >
                <Form onSubmit={registrarEspacio} isSubmitting={isSubmitting}>
                    <Input name="espacio" value={espacio} label="espacio" onChange={setEspacio} />
                    <Input name="descripcion" value={descripcion} label="descripcion" onChange={setDescripcion} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar nuevo espacio*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar espacio" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionEspacio}  isSubmitting={isSubmitting} type='update'>
                    <Input name="espacio" value={espacio} label="espacio" onChange={setEspacio} />
                    <Input name="descripcion" value={descripcion} label="descripcion" onChange={setDescripcion} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un accion*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarEspacio}
                mensaje="¿Estás seguro de que deseas eliminar espacio?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default Espacio
